import axios from "axios";

class PluginsService {
    async list() {
        return await axios.get('/api/v1/plugins')
            .then(response => response.data);
    }

    async delete(plugin_id) {
        return await axios.delete(`/api/v1/plugins?plugin_id=${plugin_id}`)
            .then(response => response.data);
    }

    async load(link) {
        return await axios.get(`/api/v1/plugin?link=${link}`)
            .then(response => response.data);
    }

    async info(link) {
        return await axios.get(`/api/v1/plugin-info?link=${link}`)
            .then(response => response.data);
    }
}

const pluginsService = new PluginsService();
export default pluginsService;